import React, {FunctionComponent, useMemo} from 'react';
import {Box, Link as MuiLink, makeStyles} from '@material-ui/core';
import {FormattedMessage as FM} from 'react-intl';
import {useSelector} from 'react-redux';
import {RegionId, RoleId, UserInfo} from 'common/types';
import {UsersAPI} from '../../../../services/UsersAPI';
import {
  newOwnerBonusSelector, newOwnerBonusStandardDateSelector,
  newRieltorBonusSelector,
  newRieltorBonusStandardAmountSelector,
} from '../../../../store/global/selectors';
import {getNewUserBonus} from '../../../../utils';
import RouterLink from '../../RouterLink';


const ALERT_NEW_RIELTOR_KO_BONUS = "200";
const ALERT_NEW_RIELTOR_KO_BONUS_OLD_USERS = "210";

const ALERT_NEW_RIELTOR_TOP_BONUS_OLD_USERS = "325";

const ALERT_NEW_RIELTOR_REGIONS_BONUS = "360";

const ALERT_NEW_OWNER_KO_BONUS = "220";
const ALERT_NEW_OWNER_KO_BONUS_OLD_USERS = "221";


const NEW_USER_BONUS_KO_ALERTS: any = {
  [RoleId.Realtor]: [ALERT_NEW_RIELTOR_KO_BONUS, ALERT_NEW_RIELTOR_KO_BONUS_OLD_USERS],
  [RoleId.Owner]: [ALERT_NEW_OWNER_KO_BONUS, ALERT_NEW_OWNER_KO_BONUS_OLD_USERS]
};

const NEW_USER_BONUS_TOP_ALERTS: any = {
  [RoleId.Realtor]: [ALERT_NEW_RIELTOR_TOP_BONUS_OLD_USERS, 0],
  [RoleId.Owner]: [0, 0]
}

const NEW_USER_BONUS_REGIONS_ALERTS: any = {
  [RoleId.Realtor]: [ALERT_NEW_RIELTOR_REGIONS_BONUS],
  [RoleId.Owner]: [0]
}

interface NewBonusAlertProps {
  user: UserInfo;
  isUserAlertVisible: any;
  isAlertStatusVisible: (user: UserInfo, id: string, usersAPI: UsersAPI) => boolean;
  classes: any;
  handleUserAlertClose: (id: string) => void;
}
const NewRieltorBonusAlert : FunctionComponent<NewBonusAlertProps> = ({classes, user, isUserAlertVisible, isAlertStatusVisible, handleUserAlertClose}: NewBonusAlertProps) => {
  // const classes = useStyles();

  const usersAPI = useMemo(() => new UsersAPI(), []);

  const newRieltorBonuses = useSelector(newRieltorBonusSelector);
  const newOwnerBonuses = useSelector(newOwnerBonusSelector);
  const newRieltorBonusStandardDate = useSelector(newRieltorBonusStandardAmountSelector);
  const newOwnerBonusStandardDate = useSelector(newOwnerBonusStandardDateSelector);



  const userBonuses = user.roleId === RoleId.Realtor ?
      newRieltorBonuses :
      (user.roleId === RoleId.Owner ? newOwnerBonuses : null);
  const newBonusStandardDate = user.roleId === RoleId.Realtor ?
      newRieltorBonusStandardDate :
      (user.roleId === RoleId.Owner ? newOwnerBonusStandardDate : '');

  const {active: newUserBonusActive, bonus: newUserBonusCoins, isNewUser: showStandardAlert} = !userBonuses ?
      {active: false, bonus: 0, isNewUser: false} :
      getNewUserBonus(userBonuses, user.tariffKey, user.createdAt, newBonusStandardDate);

  const newBonusAlert = useMemo(() => {
    if(user.roleId !== RoleId.Realtor && user.roleId !== RoleId.Owner) {
      return null;
    }
    const tariffSection = user.tariffKey;

    if (tariffSection == 'regions') {
      return NEW_USER_BONUS_REGIONS_ALERTS[user.roleId][0];
    } else if (user.regionId == RegionId.Kyiv) {
      return NEW_USER_BONUS_KO_ALERTS[user.roleId][0];
    } else return NEW_USER_BONUS_TOP_ALERTS[user.roleId][0];
  }, [user, showStandardAlert]);

  // const newBonusAlert = (user.regionId == RegionId.Kyiv ?
  //     (NEW_USER_BONUS_KO_ALERTS[user.roleId] || []) :
  //     (NEW_USER_BONUS_TOP_ALERTS[user.roleId] || [])) [0];
  const newBonusAlertOldUsers = (user.regionId == RegionId.Kyiv ?
      (NEW_USER_BONUS_KO_ALERTS[user.roleId] || []) :
      (NEW_USER_BONUS_TOP_ALERTS[user.roleId] || [])) [1];

  const userLimit = user.freeOfferLimit;

  const newBonusAlertId = newBonusAlert;
  console.log('newBonusAlertId', newBonusAlertId, newBonusStandardDate, showStandardAlert);

  if(newBonusAlertId && newUserBonusActive && !!user.hasNewRieltorBonus && !((isUserAlertVisible && isUserAlertVisible[newBonusAlertId] === false) || !isUserAlertVisible || !isAlertStatusVisible(user, newBonusAlertId, usersAPI))){

  } else {
    return null;
  }

  return (

      // {user.regionId === RegionId.Kyiv && newUserBonusActive && !!user.hasNewRieltorBonus && newBonusAlertId !== ALERT_NEW_RIELTOR_KO_BONUS_OLD_USERS && !(
      //       (isUserAlertVisible && isUserAlertVisible[newBonusAlertId] === false) ||
      //       !isUserAlertVisible || !isAlertStatusVisible(user, newBonusAlertId, usersAPI)
      //   ) &&
      <Box
          className={classes.alert}
      >
        <Box className={classes.alertPartner + ' -new-user-bonus-alert'}>
          <Box className={classes.alertPartnerClose} onClick={() => handleUserAlertClose(newBonusAlertId)}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                  d="M16 1.61143L14.3886 0L8 6.38857L1.61143 0L0 1.61143L6.38857 8L0 14.3886L1.61143 16L8 9.61143L14.3886 16L16 14.3886L9.61143 8L16 1.61143Z"
                  fill="white"/>
            </svg>
          </Box>
          <Box className={classes.alertPartnerInfo}>
            <Box className={classes.alertPartnerTitle}><FM id={'alerts.new_rieltor_bonus_alert.title'}
                                                           values={{username: user.firstName}}/></Box>

                <Box className={classes.alertPartnerText + ' -pre-wrap'}><FM id={ !userLimit ? 'alerts.new_rieltor_bonus_alert.text' : 'alerts.new_rieltor_bonus_alert.text_with_limit'}
                                                                             values={{
                                                                               coins: <span>{newUserBonusCoins}&nbsp;монет</span>,
                                                                               limit: <span>{userLimit}</span>
                                                                             }}/></Box>
          </Box>
          <Box className={classes.alertPartnerImgWr}>
            {user.roleId === RoleId.Realtor && <img
              className={classes.alertPartnerImg}
              src={require(`./images/new_rieltor_bonus_desktop_x1.png`)}
              alt=""
              srcSet={`${require(`./images/new_rieltor_bonus_desktop_x1.png`)} 1x, ${require(
                  `./images/new_rieltor_bonus_desktop_x2.png`)} 2x`}
            />}
            {user.roleId === RoleId.Realtor && <img
              className={classes.alertPartnerImgMob}
              src={require(`./images/new_rieltor_bonus_mobile_x1.png`)}
              alt=""
              srcSet={`${require(`./images/new_rieltor_bonus_mobile_x1.png`)} 1x, ${require(
                  `./images/new_rieltor_bonus_mobile_x2.png`)} 2x`}
            />}
          </Box>
        </Box>

      </Box>
// }
  );
}
// });

export default NewRieltorBonusAlert;